<script>

	import { EmojiPicker } from "../lib/ui";
	import { _ } from 'svelte-i18n';

	export let bot;
    export let button;
	let refButtonTitle;

	const clickButtonDelete = () => {
        bot.defaultChar.deleteRightButton(button);
	}

	const onEmoji = (e, type) => {
		changeButtonTitle(e.detail);
    }

	const changeButtonTitle = (addedContext = "") => {
		const title = refButtonTitle.value.slice(0, refButtonTitle.selectionEnd) + addedContext + refButtonTitle.value.slice(refButtonTitle.selectionEnd);
		button.changeTitle(title);
	}

	const clickActiveButton = () => {
		if (button.isActive()) {
			return;
		}
        bot.defaultChar.setActiveButton(button);
    }

	const changeButtonTargetLink = (e) => {
        const targetType = e.target.dataset.type;
        let targetLink = e.target.value;
        button.changeTargetLink(targetLink, targetType);
    }
</script>
<div class="content-con-wrapper" >
	{#if button.isTargetTypeLink()}
	<img width="15" loading="lazy" src="/static/images/move-icon.svg" alt="" class="image-145">
	<div class="link-block-wrap">
		<div class="link-block" class:active={button.active} on:click={clickActiveButton}>
			<div class="link-block-title">
				<div class="title"><img loading="lazy" src="/static/images/link-btn-icon.svg" alt="" class="image-146">
					<div class="text-block-93">{$_('project.scenario.30')}</div>
				</div>
				<div class="button-action-wrapper">
					<img loading="lazy" src="/static/images/trashcan-icon.svg" on:click={clickButtonDelete}>
				</div>
			</div>
			<div class="linktext-block-form">
				<div class="text-block-94">{$_('project.scenario.31')}</div>
				<div class="linktext-input-form-copy w-form">
					<div id="button-title" method="get" class="link-form" on:click|stopPropagation>
						<input type="text" class="name-text-form w-input" maxlength="256" name="name-4" bind:this={refButtonTitle} placeholder={$_('project.scenario.32')} id="name-4" value={button.title} on:blur={()=>changeButtonTitle()} on:change={()=>changeButtonTitle()} >
						<EmojiPicker on:emoji={onEmoji} />
					</div>
				</div>
			</div>
			<div class="link-block-form">
				<div class="text-block-94">{$_('project.scenario.33')}</div>
				<div class="div-block-76">
					<div class="link-input-form w-form" on:click|stopPropagation>
						<div id="email-form" name="email-form" data-name="Email Form" method="get" class="link-form">
							<input type="text" class="name-text-form w-input" data-type="LINK" autofocus="true" maxlength="256" name="field" placeholder={$_('project.scenario.34')} id="field-3" value={button.targetLink} on:blur={(e)=>changeButtonTargetLink(e)} on:change={(e)=>changeButtonTargetLink(e)}>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	{/if}
</div>
<style>

	.link-block-wrap {
		width: 100%;
	}

	.link-input-form {
		width: -webkit-fill-available;
	}

	.active {
        border: 2px solid #4c4fa7a6;
    }

	.button-action-wrapper img {
        cursor: pointer;
    }

	.name-text-form {
		margin-right: 10px;
		width: 100%;
	}

	.link-form {
		border-radius: 3px;
    	padding: 5px 14px;
		height: 37px;
	}
</style>